// extracted by mini-css-extract-plugin
export default {"button":"delete-button_button__lrS6O"};